export default "__VITE_ASSET__Bn$vHiK$__"